import React, { useEffect, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import brandAPI from "../../api/brandApi";
import BrandCard from "../brands/Card";

import {
  Swiper,
  SwiperSlide,
  Navigation,
  Pagination,
  Autoplay,
} from "../homepage/Shared/CustomSwiper";

function ListPage() {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");

  useEffect(() => {
    fetchBrand();
  }, []);

  const fetchBrand = async () => {
    try {
      const res = await brandAPI.listing();

      if (res.code === 200) {
        const { brands, totalCount } = res.data;
        setItems(brands);
        setTotalCount(totalCount);
      }
    } catch (err) {
      console.error("Error loading brands:", err);
    }
  };

  return (
    <>
      <Breadcrump title="Brand" />

      <section className="s-term-user flat-spacing-25">
        <div className="container">
          <div className="blog-count text-left mb-4">
            Total: <b>{totalCount}</b> brand
          </div>

          {items && items.length > 0 && (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              navigation={true}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: { slidesPerView: 2 },
                576: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                992: { slidesPerView: 5 },
                1200: { slidesPerView: 6 },
              }}
              className="brands-swiper"
            >
              {items.map((item, index) => (
                <SwiperSlide key={index}>
                  <BrandCard item={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </section>
    </>
  );
}

export default ListPage;